import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { call, put } from 'redux-saga/effects';

import httpClient from 'services/httpClient';
import IPostResetPasswordRequest from 'services/httpClient/request/auth/IPostResetPassword';
import IHttpClientSuccess from 'services/httpClient/responses/default/IHttpClientSuccess';

import { authActions } from '../index';
import { IResetPasswordRequestAction } from '../reducers/resetPassword/request';

function* resetPassword(action: PayloadAction<IResetPasswordRequestAction>) {
  try {
    const body: IPostResetPasswordRequest = {
      newPassword: action.payload.data.newPassword,
      recoveryToken: action.payload.data.recoveryToken,
    };

    const {
      data: { message },
    }: AxiosResponse<IHttpClientSuccess> = yield call(
      httpClient.post,
      'sessions/passwords/reset',
      body,
    );

    yield put(authActions.resetPasswordSuccess());
    action.payload.functions.success(message);
    action.payload.functions.navigateTo();
  } catch (err: any) {
    action.payload.functions.error(err);
    yield put(authActions.resetPasswordFailure());
  }
}

export default resetPassword;
